import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import logo1 from "../assets/logos/1.png";
import logo2 from "../assets/logos/2.png";


const companyLogos = {
    "1": logo1,
    "2": logo2,
};
const getLogo = (companyId) => {
    return companyLogos[companyId] || logo2;
};
const companyNames = {
    "1": "KAPIONA TECH PRIVATE LIMITED",
    "2": "STAR ENGINEERS (I) PVT. LTD.",
};

const getCompanyName = (companyId) => {
    return companyNames[companyId] || "KAPIONA TECH PRIVATE LIMITED";
};

const formatDate = (date) => {
    if (!date) return "";

    return new Date(date)
        .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "2-digit",
        })
        .replace(/ /g, "-")
        
};

const shortName = (name) => {
    if (!name) return "-";

    const parts = name.trim().split(/\s+/);

    if (parts.length === 1) {
        return parts[0];
    }

    // First Name + First Letter of Last Name
    return `${parts[0]} ${parts[parts.length - 1].charAt(0)}`;
};
const formatDayAndDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const dayName = days[d.getDay()];
    const formattedDate = formatDate(date);
    return `${dayName} & ${formattedDate}`;
};

const formatTime = (time) => {
    if (!time) return "";
    const [h, m] = time.split(":");
    const d = new Date();
    d.setHours(h);
    d.setMinutes(m);

    return d.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });
};

export const generateMomPdf = (data) => {
    const doc = new jsPDF("p", "mm", "a4");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 10;
    // Page Border
    doc.setDrawColor(0);
    doc.setLineWidth(0.4);

    doc.rect(
        margin,
        margin,
        pageWidth - margin * 2,
        pageHeight - margin * 2
    );
    const logo = getLogo(data.company_id);

    // -------------------------------------------------
    // TOP HEADER SECTION (Form Header)
    // -------------------------------------------------

    // Logo
    try {
        doc.addImage(logo, "PNG", 12, 12, 22, 10);
    } catch (e) { }

    // Company Name
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);

    doc.text(
        "MINUTES OF MEETING",
        pageWidth / 2,
        16,
        { align: "center" }
    );

    doc.setFontSize(10);

    // NEW - dynamic based on company_id
    doc.text(
        getCompanyName(data.company_id),
        pageWidth / 2,
        22,
        { align: "center" }
    );
    doc.line(10, 24, pageWidth - 10, 24);
    // -------------------------------------------------
    // METADATA GRID BOX (Exact Form Field Layout)
    // -------------------------------------------------

    const attendeesList = (data.attendance || [])
        .map((p) => shortName(p.attended_employee_name))
        .join(", ");

    const timeString = `${formatTime(data.start_time)} to ${formatTime(data.end_time)}`;



    const labelWidth = 45;
    const rowHeight = 8;
    let y = 24;

    // Draw top border
    doc.line(10, y, pageWidth - 10, y);

    const headerRows = [
        ["DAY & DATE :-", formatDayAndDate(data.meeting_date)],
        ["SUBJECT :-", data.meeting_title || "-"],
        ["MEETING ORGANIZED :-", data.organized_by_name || "-"],
        ["MEETING TIME :-", timeString],
        ["MOM PREPARED BY :-", data.prepared_by_name || "-"],
    ];

    headerRows.forEach(([label, value]) => {
        // Left border
        doc.line(10, y, 10, y + rowHeight);

        // Middle border
        doc.line(10 + labelWidth, y, 10 + labelWidth, y + rowHeight);

        // Right border
        doc.line(pageWidth - 10, y, pageWidth - 10, y + rowHeight);

        // Bottom border
        doc.line(10, y + rowHeight, pageWidth - 10, y + rowHeight);

        // Label
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(label, 12, y + 5);

        // Value
        doc.setFont("helvetica", "normal");
        doc.text(value, 10 + labelWidth + 2, y + 5);

        y += rowHeight;
    });

    let currentY = y + 4;


    // -------------------------------------------------
    // DISCUSSION POINTS TABLE
    // -------------------------------------------------
    const rows = (data.discussion_points || []).map((item, index) => [
        index + 1,
        item.point_discussed || "-",
        shortName(item.responsible_name),
        item.target_date ? formatDate(item.target_date) : "-",
        item.status || "-",
        item.remarks || "-"
    ]);
    autoTable(doc, {
        startY: currentY,
        margin: { left: margin, right: margin },
        head: [[
            "Sr.No.",
            "POINTS DISCUSSED",
            "RESP.",
            "TARGET DATE",
            "STATUS",
            "REMARK"
        ]],
        body: rows,
        theme: "plain",
        styles: {
            fontSize: 8,
            cellPadding: 2.5,
            valign: "top",
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
            textColor: [0, 0, 0]
        },
        headStyles: {
            fillColor: false,
            textColor: [0, 0, 0],
            lineWidth: 0.2,
            lineColor: [0, 0, 0],
            fontStyle: "bold",
            halign: "center"
        },
        columnStyles: {
            0: { cellWidth: 10, halign: "center" },
            1: { cellWidth: 78 },
            2: { cellWidth: 28, halign: "center" },
            3: { cellWidth: 20, halign: "center" },
            4: { cellWidth: 20, halign: "center" },
            5: { cellWidth: 34 }
        },

    });
    // -------------------------------------------------
    // ATTENDEES TABLE
    // -------------------------------------------------

    autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 3,
        margin: { left: margin, right: margin },
        theme: "plain",

        head: [["ATTENDEES"]],

        body: [
            [attendeesList],
        ],

        styles: {
            fontSize: 8,
            cellPadding: 2.8,
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
            overflow: "linebreak",
            valign: "top",
            halign: "left"
        },

        columnStyles: {
            0: {
                halign: "left"
            }
        },

        tableWidth: "auto",  // Let it auto-fit

        headStyles: {
            fillColor: false,
            textColor: [0, 0, 0],
            fontStyle: "bold",
            halign: "left",
            lineColor: [0, 0, 0],
            lineWidth: 0.2
        },
    });
    // ================= FORMAT ROW (LAST PAGE ONLY) =================

    const totalPages = doc.internal.getNumberOfPages();

    // Switch to LAST page
    doc.setPage(totalPages);

    // Fixed position near bottom of page
    const formatRowHeight = 8;
    const formatY = pageHeight - 18; // Adjust if needed

    // Draw row
    doc.line(margin, formatY, pageWidth - margin, formatY);
    doc.line(margin, formatY + formatRowHeight, pageWidth - margin, formatY + formatRowHeight);
    doc.line(margin, formatY, margin, formatY + formatRowHeight);
    doc.line(pageWidth - margin, formatY, pageWidth - margin, formatY + formatRowHeight);

    // Text
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.setTextColor(0);

    doc.text(
        "Format No.:- QR/SM/16, Rev: 03, w.e.f. :- 17.07.2026",
        pageWidth - margin - 2,
        formatY + 5,
        { align: "right" }
    );
    // -------------------------------------------------
    // FOOTER (Page Numbers & Disclaimer)
    // -------------------------------------------------


    for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.setTextColor(80);

        const footerY = pageHeight - 4;

        doc.text(
            "Document is electronically generated and is valid without a signature",
            pageWidth / 2,
            footerY,
            { align: "center" }
        );

        doc.text(
            `Page ${i} of ${totalPages}`,
            pageWidth - margin,
            footerY,
            { align: "right" }
        );
    }

    // -------------------------------------------------
    // SAVE FILE
    // -------------------------------------------------

    const fileName = `MOM_${(data.meeting_title || "Meeting")
        .replace(/[^\w\s]/gi, "")
        .replace(/\s+/g, "_")}.pdf`;

    doc.save(fileName);
};